























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { userModule } from "@/store/modules/user";
import DataResume from "@/services/DataResume";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import { storeResume } from "@/store/modules/resume";
import ResumeRalan from "@/services/ResumeRalan";
import CardDPP from "@/components/pemeriksaan/soap/CardDPP.vue";
import { storePasien } from "@/store/modules/pasien";

@Component({
  components: {
    CardModalTtd,
    CardDPP
  }
})
export default class CardResumeRalan extends Vue {
  @Prop() dtResume!: object;
  @Prop() readonly register!: string;
  // @Prop() readonly sess_login!: object;
  // inputResume = false
  sess_login = userModule.user;
  detailResume = false;
  ttd = false;
  modalOpen = false;
  resume: object = {};
  alert = "";
  dpjp = 0;
  btnTtd = false;
  btnCetak = false;
  pageTab = "tab-soap";
  paramresume = {
    reg: this.register,
    idUser: this.sess_login.id
  };
  enableQuickSign: false;
  showInput = false;

  // dtResume: Array<object>
  mounted() {
    // this.inputResume = true
    // storeResume.act_resume_on_reg(this.paramresume);
    // this.getResume();
    this.detailResume = true;
    this.ttd = true;
    // if(this.dtResume[0]==undefined){
    //     this.resume={}
    // }else{
    // this.resume=this.dtResume
    // }
    this.showInput = true;
  }
  get stateresume() {
    return storeResume.resume;
  }
  get stateuser() {
    return userModule.user;
  }
  get canSign() {
    return (
      this.stateuser.profesi == "Dokter" &&
      this.stateresume[0] &&
      this.stateresume.length != 0 &&
      this.stateresume[0]["signed"] == "0" &&
      this.stateuser.id == this.stateresume[0].dpjp["id"]
    );
  }

  get canEdit() {
    return this.stateresume[0] != null && this.stateresume[0].signed == "0";
  }

  get statePasien() {
    return storePasien.identitasPasien;
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }
  @Watch("resume")
  resumeChanged(val) {
    this.dtResume = this.resume;
    // console.log('3mount ')
    // console.log('aa ',val)
    // this.getResume();
  }
  passTtd(value) {
    appModule.setLoading(true);
    // this.dtResume
    this.dpjp = this.stateresume[0]["dpjp"]["id"];
    const dt = DataResume.saveDataTtdResume(this.register, this.dpjp, value);
    dt.then(dt => {
      appModule.setLoading(false);

      // console.log(dt['data']['status'])
      if (dt["data"]["status"] != 1) {
        appModule.addMsgTtd(dt["data"]["message"]);
        this.modalOpen = true;
        // appModule.sendErrorAlert(dt["err"]);
      } else {
        this.modalOpen = false;
        appModule.NoticeDelay("Berhasil Tanda Tangan Resume Ralan");
        // console.log("sukses ttd");
        // this.getResume();
        appModule.addMsgTtd("");
        storeResume.act_resume_on_reg(this.paramresume);
      }
    });
  }

  quickSign() {
    appModule.setLoading(true);

    const resp = ResumeRalan.quickSign(this.register);

    resp.then(dt => {
      appModule.setLoading(false);

      if (dt.data.status == 1) {
        appModule.NoticeDelay("Berhasil Tanda Tangan Resume Ralan");
        storeResume.act_resume_on_reg(this.paramresume);
      }
    });
  }

  getResume() {
    appModule.setLoading(true);

    const dt = DataResume.getDataResume(this.register, "");
    dt.then(dt => {
      appModule.setLoading(false);

      const data = dt["data"];
      this.dtResume = data;
      // console.log("resume", this.dtResume);
      // if (
      //   this.stateuser.profesi == "Dokter" ||
      //   this.stateuser.profesi == "Psikolog"
      // ) {
      //   if (this.dtResume[0] == undefined) {
      //     console.log("aa");
      //     this.btnTtd = false;
      //     this.btnCetak = false;
      //   } else {
      //     this.btnCetak = true;
      //     if (this.dtResume[0].signed == 0) {
      //       this.btnTtd = true;
      //       console.log("bb");
      //     } else {
      //       this.btnTtd = false;
      //       console.log("cc");
      //     }
      //   }
      // } else {
      //   this.btnTtd = false;
      //   if (this.dtResume[0] != undefined) {
      //     this.btnCetak = true;
      //   } else {
      //     this.btnCetak = false;
      //   }
      // }

      // console.log("pemer  ", this.dtResume[0]);
    });
  }

  modalTtd() {
    // console.log("aa")
    this.modalOpen = true;
  }
  cetakResume() {
    storeResume.act_resume_on_reg(this.paramresume);

    window.open(ResumeRalan.cetakUrl(this.stateresume[0]["id"]), "_blank");
  }
  getHumanDateTime(date) {
    return date ? moment(date).format("DD MMMM YYYY HH:mm:ss") : "";
  }
}
